import { Navbar, Nav, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useAuth } from "../componentes/AuthContext";

export const MyNavbar = () => {
  const { logout } = useAuth();

  return (
    <Navbar bg="light" expand="lg" className="px-3">
      <Navbar.Brand className="title-navbar" href="#">
        Gestión de Tareas
      </Navbar.Brand>
      <Navbar.Toggle />

      <Navbar.Collapse id="basic-navbar-nav">
        <div className="w-100 d-flex justify-content-between align-items-center flex-wrap">
          <Nav className="d-flex">
            <Nav.Link as={Link} to={"/"}>
              Tareas
            </Nav.Link>
            <Nav.Link as={Link} to={"/futuraTarea"}>
              Futuras Tareas
            </Nav.Link>
            <Nav.Link as={Link} to={"/categorias"}>
              Categorias
            </Nav.Link>
          </Nav>

          <Button
            variant="dark"
            className="rounded-pill px-3 py-1 shadow-sm mt-2 mt-lg-0"
            onClick={logout}
            size="sm"
          >
            Logout
          </Button>
        </div>
      </Navbar.Collapse>
    </Navbar>
  );
};
